import React, { FC } from 'react';
import { TranslationFunction } from 'i18next';
import classNames from 'classnames';

import styles from './ff-mobile.scss';
import FFBase from './ff-base';
import withTranslate from '../../hoc/with-translate';

type FFMobileProps = {
  pageType: string;
  t: TranslationFunction;
};

const FFMobile: FC<FFMobileProps> = ({ pageType, t, ...props }) => {
  return (
    <div data-hook="ff-content" className={classNames(styles.container, 'ma-box')}>
      <div className={styles.headerConatainer}>
        <h2 className={classNames(styles.header, 'ma-ff-title-font', 'ma-title-color')}>{t(`ff.title.${pageType}`)}</h2>
      </div>
      <FFBase pageType={pageType} {...props} />
    </div>
  );
};

export default withTranslate(FFMobile);
